/* =====================================================================
   Kroslo bundle product cards (prefix kbc).
   Shared by the Build Your Bundle page and the festive collection page,
   so a change here (copy, sizes, tag, prices) shows on both.
   Needs window.KBX (assets/kroslo-bundle.js). CSS: snippets/kroslo-bundle-cards.liquid.

   KBXCards.create({ grid, quiet, link, handles })
     grid    the element to render into
     quiet   true  = add without opening the Shopflo drawer (BYOB page)
             false = add, then open the Shopflo drawer (rest of the site)
     link    true  = photo and name link to the product page
     handles optional list of product handles to show (in that order)
     sizes   "buttons" (default) = size buttons on the card
             "count"   = just "Available in N sizes" (the default size is the one added)
     chips   optional element for the category filter chips (All, Pans, Kadhais, ...)
   Returns { render }.
   ===================================================================== */
(function () {
  "use strict";

  /* b = card subcopy: max 24 characters, ending in a full stop. Fits one line on phones 360px and wider;
     on a 320px phone a long line ends in "…" (never wraps). */
  var META = {
    "kadhai": { n: "Kadhai", b: "From tadka to deep-fry.", c: "kad", pop: "26 cm", tag: "best" },
    "shallow-kadhai": { n: "Shallow Kadhai", b: "Sabzi, stir-fry, sorted.", c: "kad", pop: "28 cm" },
    "fry-pan": { n: "Fry Pan", b: "Your everyday pan.", c: "pan", pop: "26 cm", tag: "best" },
    "wok-pan": { n: "Wok", b: "High heat, big flavour.", c: "pan" },
    "dosa-tawa": { n: "Dosa Tawa", b: "Crisp dosas, easy flips.", c: "taw", pop: "28 cm", tag: "best" },
    "roti-tawa": { n: "Roti Tawa", b: "Soft rotis, every time.", c: "taw" },
    "mortar-pestle": { n: "Mortar & Pestle", b: "Hand-ground, full aroma.", c: "acc", tag: "gift" }
  };
  var CATS = [["all", "All"], ["pan", "Pans"], ["kad", "Kadhais"], ["taw", "Tawas"], ["acc", "Accessories"]];
  var TAGS = { best: "Bestseller", gift: "Gifting favourite" };
  var LOW_STOCK = 10;

  function meta(p) { return META[p.h] || { n: p.t, b: "", c: "" }; }
  function nameOf(v) { return meta(v.product).n + (v.s ? " " + v.s.replace(/\s+/g, "") : ""); }

  function create(opts) {
    var K = window.KBX;
    var grid = opts.grid;
    if (!K || !grid) return null;
    var E = K.engine, T = K.tiers, fmt = K.fmt, esc = K.esc;
    var state = { picked: {}, busy: false, d: null, cat: "all" };

    var order = null;
    if (opts.handles && opts.handles.length) {
      order = {};
      opts.handles.forEach(function (h, i) { order[h] = i; });
    }
    function products(allCats) {
      var list = K.products.filter(function (p) {
        return (!order || order[p.h] !== undefined) && (allCats || state.cat === "all" || meta(p).c === state.cat);
      });
      if (order) list.sort(function (a, b) { return order[a.h] - order[b.h]; });
      return list;
    }
    function qtyBy(d, keyFn) {
      var m = {};
      d.src.forEach(function (s) { var k = keyFn(s); m[k] = (m[k] || 0) + s.qty; });
      return m;
    }
    function defaultVariant(p) {
      var inStock = p.v.filter(function (v) { return v.a && v.q > 0; });
      var pool = inStock.length ? inStock : p.v;
      var pop = meta(p).pop;
      for (var i = 0; i < pool.length; i++) if (pop && pool[i].s === pop) return pool[i];
      return pool[0];
    }
    function chosenVariant(p) {
      var id = state.picked[p.h];
      var v = id && K.variants[id];
      if (v && v.a && v.q > 0) return v;
      return defaultVariant(p);
    }
    /* photo: "studio" (collection page) uses each product's main Shopify photo; otherwise the festive card photo. */
    /* opts.photos (optional): { productHandle: url } overrides the photo for that product on one page only. */
    function src(p) { if (opts.photos && opts.photos[p.h]) return opts.photos[p.h]; return opts.photo === "studio" && p.f ? p.f : p.i; }
    function photo(p) {
      var img = src(p) ? '<img src="' + esc(src(p)) + '" alt="' + esc(meta(p).n) + '" loading="lazy" decoding="async" width="300" height="300">' : "";
      return opts.link && p.u ? '<a href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + img + "</a>" : img;
    }
    function title(p) {
      var n = esc(meta(p).n);
      return '<div class="kbc__nm">' + (opts.link && p.u ? '<a href="' + esc(p.u) + '">' + n + "</a>" : n) + "</div>";
    }

    function card(p, inByP, inByV) {
      var cv = chosenVariant(p);
      var soldOut = !cv.a || cv.q < 1;
      var inCount = inByP[p.h] || 0;
      var atStockLimit = cv.q - (inByV[cv.id] || 0) < 1;
      var sizes = p.v.length < 2 ? "" : opts.sizes === "count" ?
        '<div class="kbc__avail">Available in ' + p.v.length + " sizes</div>" :
        '<div class="kbc__szs" role="group" aria-label="Size">' + p.v.map(function (v) {
        var oos = !v.a || v.q < 1;
        return '<button type="button" class="kbc__sz" data-h="' + esc(p.h) + '" data-vid="' + v.id + '" aria-pressed="' + (v.id === cv.id && !oos) + '"' +
          (oos ? ' disabled aria-label="' + esc(v.s) + ', sold out"' : "") + ">" + esc(v.s) + "</button>";
      }).join("") + "</div>";
      var btnLabel = soldOut ? "Sold out" : (atStockLimit ? "No more in stock" : (inCount ? "+ Add another" : "+ Add"));
      /* Flat price (the 20%-off price); the bundle bar and cart show the bigger bundle savings. */
      var unit = cv.p, off = cv.m > cv.p ? Math.round(100 - cv.p * 100 / cv.m) : 0;
      var tag = meta(p).tag, tags = (tag ? '<span class="kbc__t kbc__t--' + tag + '">' + TAGS[tag] + "</span>" : "") +
        (inCount ? '<span class="kbc__t kbc__t--in">' + inCount + " in bundle</span>" : "");
      /* "count" cards (collection page) don't show sizes, so a piece with several sizes opens the size pop-up. */
      var anyInStock = p.v.some(function (v) { return v.a && v.q > (inByV[v.id] || 0); });
      var addHtml = opts.sizes === "count" && p.v.length > 1 ?
        '<button type="button" data-pick="' + esc(p.h) + '"' + (!anyInStock || state.busy ? " disabled" : "") + ">" +
          (anyInStock ? (inCount ? "+ Add another" : "+ Add") : "Sold out") + "</button>" :
        '<button type="button" data-add="' + cv.id + '"' + (soldOut || atStockLimit || state.busy ? " disabled" : "") + ">" + btnLabel + "</button>";
      /* product-card / product-card__info / f-price__sale f-price-item--sale are the hooks the
         Snapmint EMI script looks for (merchant config 10001); the price span is hidden, it's only for Snapmint. */
      return '<div class="kbc__card product-card' + (inCount ? " kbc__card--in" : "") + '">' +
        '<div class="kbc__ph">' + photo(p) +
          (tags ? '<div class="kbc__tags">' + tags + "</div>" : "") +
          (!soldOut && cv.q <= LOW_STOCK ? '<span class="kbc__low">Only ' + cv.q + " left</span>" : "") +
        "</div>" +
        '<div class="kbc__cb"><div class="product-card__info">' + title(p) +
        '<div class="kbc__bl">' + esc(meta(p).b) + "</div>" +
        '<div class="kbc__price num">' + fmt(unit) + (off ? "<s>" + fmt(cv.m) + '</s><span class="kbc__off">' + off + "% off</span>" : "") + "</div>" +
        '<span class="f-price__sale" hidden><span class="f-price-item--sale">' + fmt(unit) + "</span></span></div>" + sizes +
        '<div class="kbc__add">' + addHtml + "</div></div></div>";
    }

    function render(d) {
      if (d) state.d = d;
      d = state.d;
      if (!d) return;
      var inByP = qtyBy(d, function (s) { return s.v.product.h; });
      var inByV = qtyBy(d, function (s) { return s.vid; });
      grid.innerHTML = products().map(function (p) { return card(p, inByP, inByV); }).join("") ||
        '<p class="kbc__none">Nothing here yet.</p>';
      emiLine();
    }

    /* Snapmint adds its "or ₹X/month · Buy on EMI" line to cards that don't have one yet.
       Our cards redraw when the cart changes, so ask it again after each redraw
       (and a little later, in case its script hasn't loaded yet). */
    var emiTimers = [];
    function emiLine() {
      emiTimers.forEach(clearTimeout);
      emiTimers = [0, 1500, 4000].map(function (ms) {
        return setTimeout(function () {
          if (typeof window.collectionList !== "function") return;
          try { window.collectionList(".product-card"); } catch (e) {}
        }, ms);
      });
    }

    function add(vid) {
      if (state.busy) return Promise.resolve();
      var before = K.current();
      state.busy = true;
      render();
      var btn = grid.querySelector('[data-add="' + vid + '"]');
      if (btn) { btn.setAttribute("aria-busy", "true"); btn.textContent = "Adding…"; }
      return K.addVariant(vid, { quiet: !!opts.quiet }).then(function (res) {
        state.busy = false;
        render();
        if (!res.ok) { K.toast(res.message); return; }
        if (!opts.quiet) { K.openCart(); return; }   // same as the theme's add-to-cart: show the Shopflo drawer
        var after = K.current(), v = K.variants[vid];
        K.toast(before.pieces > 0 && after.pct > before.pct ?
          nameOf(v) + " added. Every piece is now " + after.pct + "% off MRP!" :
          nameOf(v) + " added: " + after.pct + "% off MRP");
      });
    }

    function renderChips() {
      if (!opts.chips) return;
      var present = {};
      products(true).forEach(function (p) { present[meta(p).c] = true; });
      opts.chips.innerHTML = CATS.filter(function (c) { return c[0] === "all" || present[c[0]]; }).map(function (c) {
        return '<button type="button" class="kbc-chip" data-cat="' + c[0] + '" aria-pressed="' + (state.cat === c[0]) + '">' + c[1] + "</button>";
      }).join("");
    }
    if (opts.chips) {
      opts.chips.addEventListener("click", function (e) {
        var el = e.target.closest("[data-cat]");
        if (!el) return;
        state.cat = el.getAttribute("data-cat");
        renderChips();
        render();
      });
      renderChips();
    }

    grid.addEventListener("click", function (e) {
      var el;
      if ((el = e.target.closest("[data-vid]"))) {
        if (!el.disabled) { state.picked[el.getAttribute("data-h")] = Number(el.getAttribute("data-vid")); render(); }
        return;
      }
      if ((el = e.target.closest("[data-pick]"))) { if (!el.disabled) Sheet.open(el.getAttribute("data-pick"), el); return; }
      if ((el = e.target.closest("[data-add]"))) { if (!el.disabled) add(Number(el.getAttribute("data-add"))); }
    });

    /* Size pop-up (prefix kbs; CSS in snippets/kroslo-bundle-cards.liquid): a sheet from the bottom on phones,
       a small centred box on desktop. Most popular size pre-selected; sold-out sizes crossed out. */
    var Sheet = { el: null, p: null, vid: 0, from: null };
    Sheet.html = function () {
      var p = Sheet.p, d = state.d;
      var inByV = d ? qtyBy(d, function (s) { return s.vid; }) : {};
      var v = K.variants[Sheet.vid], left = v.q - (inByV[v.id] || 0), pop = meta(p).pop;
      return '<div class="kbs__grab" aria-hidden="true"></div>' +
        '<div class="kbs__top">' + (src(p) ? '<img src="' + esc(src(p)) + '" alt="" width="64" height="64">' : "") +
          '<div><div class="kbs__nm">' + esc(meta(p).n) + '</div><div class="kbs__pr num">' + fmt(v.p) + "<s>" + fmt(v.m) + "</s></div></div>" +
          '<button type="button" class="kbs__x" data-kbs="close" aria-label="Close">×</button></div>' +
        '<div class="kbs__lbl">Size: <b>' + esc(v.s) + "</b>" + (pop && v.s === pop ? "<em>Most popular</em>" : "") + "</div>" +
        '<div class="kbs__szs" role="radiogroup" aria-label="Size">' + p.v.map(function (x) {
          var out = !x.a || x.q - (inByV[x.id] || 0) < 1;
          return '<button type="button" class="kbs__sz" role="radio" data-kbs-vid="' + x.id + '" aria-checked="' + (x.id === v.id) + '"' +
            (out ? ' disabled aria-label="' + esc(x.s) + ', sold out"' : "") + ">" + esc(x.s) + "</button>";
        }).join("") + "</div>" +
        (left <= LOW_STOCK ? '<div class="kbs__low">Only ' + left + " left in " + esc(v.s) + "</div>" : "") +
        '<button type="button" class="kbs__add" data-kbs="add">Add to cart · ' + fmt(v.p) + "</button>";
    };
    Sheet.render = function () { Sheet.box.innerHTML = Sheet.html(); };
    Sheet.open = function (h, from) {
      var p = K.products.filter(function (x) { return x.h === h; })[0];
      if (!p) return;
      var d = state.d, inByV = d ? qtyBy(d, function (s) { return s.vid; }) : {};
      var pool = p.v.filter(function (v) { return v.a && v.q - (inByV[v.id] || 0) > 0; });
      if (!pool.length) return;
      var pop = meta(p).pop, pick = pool.filter(function (v) { return v.s === pop; })[0] || pool[0];
      Sheet.p = p; Sheet.vid = pick.id; Sheet.from = from;
      if (!Sheet.el) {
        Sheet.el = document.createElement("div");
        Sheet.el.className = "kbs";
        Sheet.el.innerHTML = '<div class="kbs__bg" data-kbs="close"></div><div class="kbs__box" role="dialog" aria-modal="true" aria-label="Choose a size"></div>';
        document.body.appendChild(Sheet.el);
        Sheet.box = Sheet.el.querySelector(".kbs__box");
        Sheet.el.addEventListener("click", Sheet.click);
        document.addEventListener("keydown", function (e) { if (e.key === "Escape" && Sheet.el.classList.contains("kbs--in")) Sheet.close(); });
        var y0 = null;
        Sheet.box.addEventListener("touchstart", function (e) { y0 = e.touches[0].clientY; }, { passive: true });
        Sheet.box.addEventListener("touchend", function (e) {
          if (y0 !== null && e.changedTouches[0].clientY - y0 > 70 && Sheet.box.scrollTop <= 0) Sheet.close();
          y0 = null;
        }, { passive: true });
      }
      Sheet.render();
      Sheet.el.classList.add("kbs--in");
      document.documentElement.classList.add("kbs-lock");
      var sel = Sheet.box.querySelector('[aria-checked="true"]');
      if (sel) sel.focus({ preventScroll: true });
    };
    Sheet.close = function () {
      if (!Sheet.el) return;
      Sheet.el.classList.remove("kbs--in");
      document.documentElement.classList.remove("kbs-lock");
      if (Sheet.from && document.contains(Sheet.from)) Sheet.from.focus({ preventScroll: true });
    };
    Sheet.click = function (e) {
      var el = e.target.closest("[data-kbs], [data-kbs-vid]");
      if (!el || el.disabled) return;
      if (el.hasAttribute("data-kbs-vid")) { Sheet.vid = Number(el.getAttribute("data-kbs-vid")); Sheet.render(); var f = Sheet.box.querySelector('[aria-checked="true"]'); if (f) f.focus({ preventScroll: true }); return; }
      var what = el.getAttribute("data-kbs");
      if (what === "close") { Sheet.close(); return; }
      if (what === "add" && !state.busy) {
        el.setAttribute("aria-busy", "true");
        el.textContent = "Adding…";
        add(Sheet.vid).then(Sheet.close);
      }
    };
    K.subscribe(render);

    return { render: render };
  }

  window.KBXCards = { create: create, meta: meta, nameOf: nameOf };
})();
